import forwardToURL from './v2/utils/forwardToURL';
import Track from './v2/utils/tracking';

export default class TimeoutPoller {
  timeOfLastUpdate;
  keepAliveTimer;
  constructor() {}
  sendKeepAliveRequest(cookieExpiry) {
    fetch(`https://${window.location.host}/checkout/session-timeout/update?expiryTime=${cookieExpiry}`, {
      method: 'POST',
      headers: {
        'x-thg-client': 'checkout-web-js',
      },
    })
      .then((response) => {
        if (!response.ok) {
          Track.error('Failed to add session timeout cookie.');
        }
      })
      .catch(err => Track.error(`Error when adding session timeout cookie: ${err}`));
  }
  sendKeepAliveCheckRequest(redirectUrl) {
    fetch(`https://${window.location.host}/checkout/session-timeout/check`, {method: 'GET'})
      .then((response) => {
        if (response.status === 302) {
          forwardToURL(redirectUrl)
        }
      })
      .catch(err => Track.error(`Error while checking session timeout cookie: ${err}`));
  }
  resetIdleTimer(redirectUrl, checkInterval, cookieExpiry, timeNow) {
    clearTimeout(this.keepAliveTimer);
    
    if (this.timeOfLastUpdate === undefined || timeNow > this.timeOfLastUpdate + (Math.floor(checkInterval / 2))) {
      this.sendKeepAliveRequest(cookieExpiry);
      this.timeOfLastUpdate = timeNow;
    }
    
    // Set the new keep-alive timer
    this.keepAliveTimer = setInterval(() => { this.sendKeepAliveCheckRequest(redirectUrl); }, checkInterval);
  }
}